// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import React, { useImperativeHandle, forwardRef } from "react";
import { createPortal } from "react-dom";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import Clipboard from 'clipboard'
import copy from 'clipboard-copy';
import { message } from "antd";
import XtSvg from "../Svg";
export interface CopyRefProps {
  handleCopy(): void;
}
interface CopyTextProps extends BaseCompProps {
  ref?: CompRef<CopyRefProps>;
  attr?: any;
  /**copy的文本 */
  text: string;
  /**自定义copy图标 */
  icon?: React.ReactNode;
  /**操作类型copy或者cut剪切（只能用于input 或者 textarea中） */
  action?: string;
  /** 图标颜色自定义 */
  color?: string;
  /**复制结束回掉 */
  onCopy?(e: Clipboard.Event): void;
  children?(icon: React.ReactNode): React.ReactNode;
}
const { useTranslation } = Hooks;

const CopyText = ({ className, icon, color, text = "", action = "copy", onCopy, children }: CopyTextProps, ref: CopyTextProps["ref"]) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  useImperativeHandle(ref, () => ({
    handleCopy,
  }));
  const renderIcon = () => {
    return (icon || (
      <XtSvg className="copy-icon" style={{ ...(color ? { color: color } : undefined) }} src={require("@/assets/icon-svg/app/icon-copy.svg")} />
    )) as React.ReactNode;
  };
  const handleCopy = () => {

    copy(text).then(() => {
      message.success(t("account.copy"));
    })
      .catch(() => {
        message.error(t("app.copyErr"));
      });

  };
  return (
    <button
      className={cx(className, styles["copy-ctn"], "copy-btn")}
      type="button"
      onClick={handleCopy}
      data-clipboard-action={action}
      data-clipboard-target="#copy-field"
    >
      {createPortal(<input type="hidden" id="copy-field" value={text} />, document.body)}
      {children ? children(renderIcon()) : renderIcon()}
    </button>
  );
};
export default forwardRef(CopyText) as React.FC<CopyTextProps>;
